// @ts-check
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ModelContainer from './Model/ModelContainer';
import SiteTabsContainer from './SideTabsContainer/SideTabsContainer';
import FormContainer from './GlobalForm/FormContainer'
import ChartsContainer from './Model/Charts/ChartsContainer'
import FirebaseAuth from './Auth/FirebaseAuth'
import NewUserForm from './Auth/NewUserForm'
import {
  MAIN_VIEW_CLICKED
} from '../redux/actions/actionTypes'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    minHeight: "100vh",
    position: "relative"
  },
  content: {
    display: 'flex',
    flexGrow: 1,
  },
  sideWrapper: {
    display: 'flex'
  }
}));

function RootContainer() {
  const styles = useStyles();
  const dispatch = useDispatch()
  const solution = useSelector(state => state.model.renderedSolution);

  return (
    <div
      className={styles.root}
      onClick={() => {
        dispatch({
          type: MAIN_VIEW_CLICKED,
        })
      }}
    >
      <FirebaseAuth />
      <NewUserForm />
      <div className={styles.sideWrapper}>
        <SiteTabsContainer />
        <FormContainer />
      </div>
      <div className={styles.content}>
        {
          solution &&
          <ChartsContainer />
        }
        <ModelContainer />
      </div>
      {/* <script src="src/3DEngine/plooto3D.js" /> */}
    </div>
  )
}

export default RootContainer;
